import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateModule } from "@ngx-translate/core";

/** Shows the maintenance notice and its soft spinner. */
@Component({
  selector: "app-maintenance",
  templateUrl: "./maintenance.component.html",
  styleUrls: ["./maintenance.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateModule]
})
export class MaintenanceComponent implements OnInit {
  constructor(private readonly spinner: NgxSpinnerService) {}

  ngOnInit() {
    this.spinner.show("spinner-soft");
  }
}
